import { generarNumeroAleatorioEntero } from '../utils/numbers';

// MELI viene devolviendo el valor de `list_cost` (free_shipping_cost.coverage.all_country.list_cost)
// como costo operativo fijo en MX/CO cuando el listing NO tiene free shipping habilitado.
// En esos casos, lo movemos a los campos de fixrate para que la UI y los cálculos lo traten
// como fixrate (costo operativo) en lugar de free shipping.
function applyOperatingCostNormalization(item, countryName) {
	const isMxOrCo = countryName === 'MEXICO' || countryName === 'COLOMBIA';
	if (!isMxOrCo) return item;
	if (item?.freeshipping === true) return item;

	const operatingCostGross = item?.freeshippingcostr || item?.freeshippingcostc || 0;
	if (operatingCostGross <= 0) return item;

	const operatingCostNoIva =
		item?.freeshippingcostnoivar || item?.freeshippingcostnoivac || 0;

	return {
		...item,
		// El operating cost se muestra y se calcula como fixrate (no como FS).
		fixrate: operatingCostGross,
		fixratenoiva: operatingCostNoIva,
		// Marca para que calculateProyectedData sepa que este fixrate es el operating cost
		// y deba mantenerlo aplicado independientemente del umbral basefreeshipping.
		isMeliOperatingCost: true,
		// Limpiamos los campos de FS para que nada los renderice como tal.
		freeshippingcostc: 0,
		freeshippingcostr: 0,
		freeshippingcostnoivac: 0,
		freeshippingcostnoivar: 0,
	};
}

export default function mapPricingResponse(response, countryName) {
	try {
		const res = response?.data?.[0];
		const resItems =
			countryName === 'MEXICO'
				? JSON.parse(res.func_getpricing_mex)
				: countryName === 'COLOMBIA'
				? JSON.parse(res.func_getpricing_col)
				: countryName === 'ARGENTINA'
				? JSON.parse(res.func_getpricing_arg)
				: JSON.parse(res.func_getpricing_query_filtered);

		const items = resItems.items.map((item) => ({
			...applyOperatingCostNormalization(item, countryName),
			id: `${item.itemid}-${generarNumeroAleatorioEntero(1, 10000)}`,
		}));

		const dolarPrice =
			countryName === 'MEXICO'
				? resItems.cotizacion[0].mxn.toFixed(2)
				: countryName === 'COLOMBIA'
				? resItems.cotizacion[0].cop.toFixed(2)
				: countryName === 'BRASIL'
				? resItems.cotizacion[0].bra.toFixed(2)
				: resItems.cotizacion[0].ars.toFixed(2);

		const stats = resItems.items.reduce(
			(acc, item) => {
				if (item.cataloglisting) acc.catalog++;
				if (item.status === 'active') acc.active++;
				if (item.status === 'paused') acc.paused++;

				return acc;
			},
			{ catalog: 0, active: 0, paused: 0 }
		);

		const total_sku = resItems?.total_sku;

		console.log('items', items);

		return {
			items,
			dolarPrice,
			stats,
			total_sku,
			...(countryName === 'ARGENTINA' && {
				total_listings_vtex: resItems?.total_listings_vtex,
			}),
			...(countryName === 'MEXICO' && {
				total_listings_amz: resItems?.total_listings_amz,
			}),
		};
	} catch (error) {
		console.error('GetPricingFiltered');
		console.error(error);
	}
}
